module.exports = __webpack_public_path__ + "img/google_btn.72633beb.png";